module.exports = {
  messages: {
    BUTTON_BACK: 'Indietro',
    COMMUNICATION_ERROR_500_SUBLINE:
      'Ma dovrebbe tornare presto operativo. Ci scusiamo e ti ringraziamo per la pazienza.',
    COMMUNICATION_ERROR_500_TITLE:
      'Sembra che il nostro sistema stia facendo una pausa caffè.',
    JOBS_FIND_JOBS_SEARCH_BUTTON: 'Trova un impiego',
    LOSP_SWIMP_COMPANY_LABEL: 'Presso quale azienda e in quale città?',
    LOSP_SWIMP_COMPANY_PLACEHOLDER: 'Per es. REWE GROUP a Colonia',
    LOSP_SWIMP_CONTINUE_BUTTON: 'Avanti',
    LOSP_SWIMP_ERROR_BUTTON_PROMPT: 'Indietro',
    LOSP_SWIMP_ERROR_BUTTON_SYSTEM: 'Tenta nuovamente',
    LOSP_SWIMP_ERROR_TEXT_PROMPT:
      'Inserisci almeno ruolo e azienda. Puoi aggiungere anche la tua sede.',
    LOSP_SWIMP_ERROR_TITLE_PROMPT: 'Senza un input concreto, non sarà facile.',
    LOSP_SWIMP_LOADING_SUBTITLE:
      'e sta trovando le offerte di lavoro adatte a te.',
    LOSP_SWIMP_LOADING_TITLE:
      'Creazione del profilo in corso con l’IA di XING...',
    LOSP_SWIMP_ROLE_LABEL: "Qual'è la tua situazione professionale attuale?",
    LOSP_SWIMP_ROLE_PLACEHOLDER:
      'Per esempio: Product Manager e professionista di Excel',
    LOSP_SWIMP_SUBTITLE:
      'Crea subito il tuo profilo di ricerca lavoro con l’IA di XING',
    LOSP_SWIMP_TITLE_B: 'Clic, clic',
    LOSP_SWIMP_TITLE_C: 'Match veloce',
  },
};
